// DaysFoodsComponent.js
import React, { useEffect, useState } from 'react'
import { ADayFoodsComponent } from './ADayFoodsComponent'
import { GetReserveDays_Reserve_Api } from '../../API/ReserveApi';
import { Row ,Typography,Space, Card, Alert, message } from 'antd';
import { UserOutlined, CalendarOutlined } from '@ant-design/icons'

const { Text } = Typography;

export const DaysFoodsComponent = ({
    setLoading,
    showMessage,
    reserve,
    reportMode = false,
}) => {
    // ======================================================================
    const [days, setDays] = useState([]);
    // ======================================================================
    useEffect(() => {
        loadReserveDays();
    }, []);
    // ======================================================================
    const loadReserveDays = async () => {
        setLoading(true);
        try {
            const data = await GetReserveDays_Reserve_Api(reserve.id);
            setLoading(false);
            if (data.messageStatus === "Successful") {
                setDays(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================

    return (
        <div className='container'>
             {/* کارت توضیح */}
            <Card
                style={{
                    borderRadius: '10px',
                    marginBottom: '20px',
                    borderLeft: '4px solid #ee5914ff',
                    backgroundColor: '#f8d76996'
                }}
                size="small"
            >
                <Space>
                    <Text type="secondary">
                        <UserOutlined style={{ marginLeft: '8px' }} />
                        توجه: حداکثر تعداد قابل رزرو برابر با تعداد نفرات رزرو ({reserve.reserve_Users?.length || 0} نفر) می‌باشد.
                    </Text>
                    <Alert
            type="warning"
            showIcon
            icon={<CalendarOutlined />}
            message="توجه: رزرو غذا/پارکینگ فقط 7 روز قبل از شروع اقامت تا 1 روز قبل از شروع اقامت امکان‌پذیر می باشد."
            style={{
                borderRadius: '8px'
            }}
        />
                </Space>
            </Card>

            <Row gutter={[16, 24]}>
                {days && days.length > 0 ? (
                    days.map((day, index) => ( // <<<<<<<<<<< اینجا index را اضافه می‌کنیم
                        <ADayFoodsComponent
                            key={day.id}
                            setLoading={setLoading}
                            showMessage={showMessage}
                            reserve={reserve}
                            day={day}
                            reportMode={reportMode}
                            dayIndex={index} // <<<<<<<<<<< index را به عنوان dayIndex ارسال می‌کنیم
                        />
                    ))
                ) : (
                    <div style={{ width: '100%', textAlign: 'center', padding: '20px' }}>
                        روزهای رزرو یافت نشد
                    </div>
                )}
            </Row>
        </div>
    )
}